import DashboardRateCardBlock, { DashboardRateCardBlockProps } from './DashboardRateCardBlock';

export type { DashboardRateCardBlockProps };
export default DashboardRateCardBlock;
